'use client'
import React,{useState} from 'react';
import EmployAside from '../../aside';
import DevisCreate from './devisCreate';

const EmployDashboardProfilePage = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (   

    <div className='main-page-wrapper'>
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <DevisCreate setIsOpenSidebar={setIsOpenSidebar}/>
    </div>    
  );
};

export default EmployDashboardProfilePage;